import { z } from 'zod';

export function isDateOnlyISOString(dateString: string) {
  return z.string().date().safeParse(dateString).success;
}
